var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-wrapper"},[_c('div',{class:[
      'form-wrapper__header',
      { 'form-wrapper__header--altcolor': _vm.altcolor }
    ]},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c(_vm.icon,{tag:"component"})],1),_c('div',{staticClass:"form-wrapper__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }